<template>
  <client-module :moduletitle="moduletitle">
    <span slot="customHint" class="hint">{{ hint }}</span>
    <div class="welcome-speech">
      <div class="set-data">
        <div class="switch">
          <span>是否打开</span>
          <el-switch
            v-model="switchValue"
            active-color="#40a1fb"
            inactive-color="#dcdfe6"
            @change="switchChange"
            :disabled="disabled"
          >
          </el-switch>
        </div>
        <div class="form">
          <slot></slot>
        </div>
      </div>
      <div class="show-data">
        <div class="top">
          <ig-icon name="zuojiantou"></ig-icon>
          <div class="name">
            {{ welcomeData.name }}
          </div>
        </div>
        <div class="welcome-content">
          <slot name="mobile"></slot>
        </div>
      </div>
    </div>
  </client-module>
</template>

<script>
import clientModule from '@/components/client/clientModule/clientModule.vue';
export default {
  props: {
    moduletitle: {
      type: String
    },
    hint: {
      type: String
    },
    welcomeData: {
      type: [Object, String, Array]
    },
    disabled: {
      type: Boolean
    },
    switchVal: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      switchValue: false
    };
  },
  methods: {
    switchChange(val) {
      this.$emit('switchChange', val);
    }
  },
  components: { clientModule },
  watch: {
    switchVal: {
      handler(val) {
        this.switchValue = val;
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
.client-module {
  background-color: #fff;
  margin-bottom: 10px;
}
.welcome-speech {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  color: #333;
  padding: 60px 60px 10px;
  .set-data {
    width: 50%;
    .switch {
      display: flex;
      align-items: center;
      margin-bottom: 50px;
      span {
        margin-right: 10px;
      }
    }
  }
  .show-data {
    width: 330px;
    line-height: 16px;
    padding: 52px 25px 0;
    background-image: url(https://img.iglobalwin.com/image/mobile.png);
    background-size: 100%;
    background-repeat: no-repeat;
    .top {
      width: 100%;
      height: 44px;
      font-size: 10px;
      text-align: center;
      padding: 4px 0;
      padding-right: 20px;
      background-color: #f7f7f8;
      display: flex;
      justify-content: space-around;
      align-items: center;
      .iconfont {
        margin-right: 10px;
      }
      .name {
        /* 多行溢出隐藏 */
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
    }
    .welcome-content {
      width: 100%;
      height: 100%;
      padding: 15px 10px;
      color: #999;
      line-height: 16px;
      text-align: left;
      word-break: break-all;
      text-indent: 16px;
    }
  }
}
.hint {
  font-size: 12px;
  color: #999;
  margin-left: 10px;
}
</style>
